import { Module } from '../Module';

// A styled version of input[type='file']
export interface IFileInputScope extends ng.IScope {
  // a unique id to link the label to the file input
  fileUploadId: string;
  // the path of the selected file
  filename: string;
  // HTML5 File object
  file: File;
  // if this attribute is present, the file is required for form submission
  required: any;
   //localization key for the file name label
  filenameLocalizationKey: string;
  // whether or not the file input is disabled.
  // This property can be set by adding the attribute disabled=true to the tbFileInput element.
  // It's necessary to disable child elements created by this directive.
  disabled: boolean;
}

interface IFileInputAttributes extends ng.IAttributes {
  name: string;
  required: string;
  filenameLocalizationKey: string;
}

let id = 0;

Module.instance().directive('tbFileInput', <any[]>[
  () => {
    return {
      restrict: 'E',
      scope: {
        name: '@',
        file: '=?',
        filenameLocalizationKey: '@',
        disabled: '='
      },
      replace: true,
      templateUrl: 'fileInput.html',
      link: (scope: IFileInputScope, element: JQuery, attr: IFileInputAttributes) => {
        scope.required = !!attr.required; // coalesce to boolean because this is used by ng-required
        scope.fileUploadId = 'file-upload-' + id++;

        // <input type="file"/> in Angular 1.2.13+ does not update the ngModel attribute.
        // Set up a listener to manually update the ngModel value.
        const fileInput = element.find('input[type="file"]');
        fileInput.change(() => scope.$evalAsync(() => {
          scope.file = (<any>fileInput[0]).files[0];
          // all browsers, even on mac, use c:\fakepath here
          // IE will use fake path unless security settings are low enough, in which case it will use the full path
          // the full path is often too long to display, so we just drop it and keep the filename only.
          const fileInputValue = fileInput.val() as string;
          scope.filename = fileInputValue.split('\\').pop(); // remove path, keep only filename
        }));
      }
    };
  }
]);
